export const enum FlowResultFileApprovalStatuses {
  Editing = "editing", // The file is not yet submitted for review.
  Approved = "approved",
  Denied = "denied",
  Pending = "pending",
  RequestedChanges = "requestedChanges",
}
